module.exports = __webpack_public_path__ + "static/107-735b69f9417eedf1278f23c7d8ba055f.png";